import { Button, Flex } from "@capioweb/ui-components"
import React from "react"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { LocalesContext } from "../../context"
import { BlockCommonLayout } from "../../utils/layout"
import { SavedArticle, SavedArticleProps } from "./SavedArticle"

interface MyPagesSavedArticlesBlockProps {
	heading: StringProperty
	articles: SavedArticleProps[]
	savedArticles?: string[] // List of article guids
}

const MyPagesSavedArticlesBlock: React.FC<MyPagesSavedArticlesBlockProps> = ({
	articles,
	savedArticles,
	...rest
}) => {
	const { translate, translationKeys } = React.useContext(LocalesContext)

	const numberOfInitialArticles = 4
	const [visibleArticles, setVisibleArticles] = React.useState(
		articles?.slice(0, numberOfInitialArticles) ?? []
	)
	const showAll = () => setVisibleArticles(articles)

	return (
		<BlockCommonLayout {...rest} backgroundColor="blue11">
			<Flex w={1} flexDirection={"column"}>
				<Flex w={1} flexDirection="column" rowGap={3}>
					{visibleArticles.length > 0 &&
						visibleArticles.map((article, i) => {
							return <SavedArticle {...article} key={i} />
						})}
				</Flex>
				{visibleArticles?.length !== articles.length && (
					<Flex w={1} justifyContent="center">
						<Button
							variant="ghost"
							textColor="navy"
							icon="plus"
							onClick={showAll}
							mt={{ _: 2, l: 5 }}
						>
							{translate(translationKeys.showMore) &&
								translate(translationKeys.showMore)}
						</Button>
					</Flex>
				)}
			</Flex>
		</BlockCommonLayout>
	)
}

export { MyPagesSavedArticlesBlock }
